import * as React from "react";
import { Link } from "react-router-dom";

/**
 * The TCPA marketing-consent disclosure shown on every account-creation form
 * (the auth-gate popup's create-account view and the standalone /signup page).
 *
 * This is the single source of truth for the legal wording so it stays
 * byte-identical across surfaces — only the surrounding checkbox chrome and
 * styling differ per surface. Render it inside that surface's consent-text
 * span, e.g. `<span className="auth-gate__check-txt"><TcpaConsentText /></span>`.
 *
 * The Terms / Privacy links open in a new tab (so reading them doesn't tear
 * down a half-filled signup form) and stop click propagation so following a
 * link never toggles the checkbox the text labels.
 */
export function TcpaConsentText(): React.ReactElement {
  return (
    <>
      By submitting, I expressly consent to receive marketing phone calls, voicemails, and text
      messages from Sports Academy Games at the number provided above. I agree that these calls and
      voicemails may be made using an automatic telephone dialing system or an artificial or
      prerecorded voice. I understand that my consent is not a condition of purchase. I also agree
      that this consent applies even if my number is currently listed on any state, federal, or
      internal Do-Not-Call list. Msg &amp; data rates may apply. Reply STOP to opt out. View our{" "}
      <Link
        to="/terms"
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
      >
        Terms of Service
      </Link>{" "}
      and{" "}
      <Link
        to="/privacy"
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
      >
        Privacy Policy
      </Link>
      .
    </>
  );
}
